<div class="modal-header blue">
  <h4 class="modal-title">Group Enrollments</h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<div class="modal-body p-0">
  <groups [groupId]="groupId" [isReadOnly]="isReadOnly"></groups>
</div>
